__turbopack_context__.v({
  "link": "KMQXTa_link",
  "linkActive": "KMQXTa_linkActive",
  "list": "KMQXTa_list",
});
